import { orderIndexBulkUpdate } from '@dispatch/shared/services';
import { TasksListFilter } from '@dispatch/shared/types';
import { useMutate } from '../api/useMutate';

export const useFiltersOrderIndexBulkUpdate = (
  responseFn: (data: { success: boolean }) => void | Promise<unknown>,
  userId: string
) => {
  const { mutate, error, status } = useMutate(
    ['upsert-task-filter', userId],
    (data: Omit<TasksListFilter, 'pageSize'>[]) =>
      orderIndexBulkUpdate(data, userId),
    responseFn as (data: unknown) => void | Promise<unknown>
  );

  return {
    orderIndexBulkUpdate: mutate,
    orderIndexBulkUpdateError: error,
    orderIndexBulkUpdateStatus: status,
  };
};
